/**
 * The month grid behind the date field's calendar: which days to draw, in
 * Sunday-first weeks, with blanks before the 1st. Pure calendar arithmetic on
 * `YYYY-MM-DD` dates, so it is the same in every time zone.
 */
import { isoDate } from './date-time-input';

export interface MonthCursor {
  year: number;
  /** 1-based. */
  month: number;
}

/** The month a `YYYY-MM-DD` date falls in, or null for anything else. */
export function monthOf(value: string): MonthCursor | null {
  const m = /^(\d{4})-(\d{2})-\d{2}$/.exec(value);
  return m ? { year: Number(m[1]), month: Number(m[2]) } : null;
}

/** The month `delta` months before or after `cursor`. */
export function shiftMonth(cursor: MonthCursor, delta: number): MonthCursor {
  const zeroBased = cursor.year * 12 + (cursor.month - 1) + delta;
  return { year: Math.floor(zeroBased / 12), month: (zeroBased % 12) + 1 };
}

/** The month's cells, Sunday first: `null` for a blank before the 1st, else
 *  the day's `YYYY-MM-DD`. */
export function monthCells({ year, month }: MonthCursor): Array<string | null> {
  const leading = new Date(Date.UTC(year, month - 1, 1)).getUTCDay();
  const days = new Date(Date.UTC(year, month, 0)).getUTCDate();
  const cells: Array<string | null> = Array.from({ length: leading }, () => null);
  for (let day = 1; day <= days; day += 1) cells.push(isoDate(year, month, day));
  return cells;
}
